<div class="grid grid-cols-1 lg:grid-cols-[56%_1fr]">
  <div class="relative h-20 w-full lg:h-screen">
    <img
      class="size-full bg-[url('/assets/images/login-bg-preview.webp')] bg-cover bg-no-repeat object-cover object-[left_58%] lg:object-[45%_center]"
      ngSrc="assets/images/login-bg.webp"
      alt=""
      fill="true"
      fetchpriority="high"
      priority="high"
    />
    <div
      class="absolute right-8 bottom-2/4 translate-y-1/2 rounded-xl bg-white/80 p-4 lg:right-14 lg:bottom-16 lg:translate-y-0"
    >
      <img
        class="w-28 lg:w-full"
        ngSrc="assets/images/logo.svg"
        alt="logo"
        height="95"
        width="295"
      />
    </div>
  </div>
  <div class="w-full p-16 lg:flex lg:flex-col lg:justify-center 2xl:px-32">
    <router-outlet />
  </div>
</div>
